import * as Immutable from 'seamless-immutable';
import {
  REQUIRED_FIELDS_FETCH_API_FULFILLED,
  REQUIRED_FIELDS_FETCH_API_REJECTED,
  REQUIRED_FIELDS_FETCH_START,
  REQUIRED_FIELDS_UPDATE,
  REQUIRED_FIELDS_UPDATE_API_FULFILLED,
  REQUIRED_FIELDS_UPDATE_API_REJECTED,
  REQUIRED_FIELDS_UPDATE_START
} from '../actions';

const initialState = Immutable.from({
  loading: false,
  isUpdating: false,
  /**
   * @type [key: ISSUE_ATTRIBUTE_NAMES]: { isRequired: boolean }
   * */
  fields: {},
  /* [key: ISSUE_ATTRIBUTE_NAMES]: boolean */
  changedFields: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUIRED_FIELDS_UPDATE: {
      const {fieldName, isRequired} = action.payload;
      return state.setIn(['changedFields', fieldName], {isRequired});
    }
    case REQUIRED_FIELDS_FETCH_START:
      return state.merge({loading: true});
    case REQUIRED_FIELDS_FETCH_API_FULFILLED:
      return state.merge({loading: false, fields: action.payload});
    case REQUIRED_FIELDS_FETCH_API_REJECTED:
      return state.merge({loading: false});
    case REQUIRED_FIELDS_UPDATE_START:
      return state.merge({isUpdating: true});
    case REQUIRED_FIELDS_UPDATE_API_FULFILLED:
      return state.merge({isUpdating: false, fields: action.payload});
    case REQUIRED_FIELDS_UPDATE_API_REJECTED:
      return state.merge({isUpdating: false});
    default:
      return state;
  }
};
